import Box from '@zenbusiness/zui/Box';
import Grid from '@zenbusiness/zui/Grid';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import ImageViewModal from '#client/components/ImageViewModal';
import useModalContext from '#client/hooks/useModalContext';

export default function CheckDepositImage({ frontImage, backImage }) {
  const { openModal } = useModalContext();

  const handleClickImage = (base64Image, title) => () => {
    openModal({
      component: ImageViewModal,
      base64Image,
      title
    });
  };

  return (
    <Grid
      item
      xs={12}
    >
      <Grid
        columnSpacing="8px"
        container
        rowSpacing={{ xs: '16px', md: '32px' }}
      >
        <Grid
          item
          md={4}
          xs={12}
        >
          <Stack
            direction="column"
            gap="8px"
          >
            <Text
              color="secondary"
              size="xs"
              uppercase
            >
              Front of check
            </Text>
            {!frontImage ? (
              <Skeleton
                height="72px"
                width="128px"
              />
            ) : (
              <Box
                aria-label="front-image"
                onClick={handleClickImage(frontImage, 'Front of check')}
              >
                <img
                  alt="front"
                  height="72px"
                  src={frontImage}
                  style={{ borderRadius: '12px' }}
                  width="128px"
                />
              </Box>
            )}
          </Stack>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
        >
          <Stack
            direction="column"
            gap="8px"
          >
            <Text
              color="tertiary"
              size="xs"
              uppercase
            >
              Back of check
            </Text>
            {!backImage ? (
              <Skeleton
                height="72px"
                width="128px"
              />
            ) : (
              <Box
                aria-label="back-image"
                onClick={handleClickImage(backImage, 'Back of check')}
              >
                <img
                  alt="front"
                  height="72px"
                  src={backImage}
                  style={{ borderRadius: '12px' }}
                  width="128px"
                />
              </Box>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  );
}

CheckDepositImage.propTypes = {
  frontImage: PropTypes.string,
  backImage: PropTypes.string
};
